document.addEventListener('DOMContentLoaded' , () =>{
    // product - js-btn-col
    if(document.querySelector('.js-btn-col')){
        const btnCol = document.querySelector('.js-btn-col'),
              prdList = document.querySelectorAll('.prd-list'),
              prdListPage = document.querySelector('.product-lists-page');
        

		btnCol.addEventListener('click' , function(e){
            let targetBtn = e.target.parentElement;

			targetBtn.classList.toggle('on');

			//목록 스타일
			if(targetBtn.classList.contains('on')){
				targetBtn.className = 'js-btn-col on'

                
                if(document.querySelector('.search-product-lists-page')){
                    prdListPage.className = 'content product product-lists-page product-lists-page--wide search-product-lists-page';
                }else{
                    prdListPage.className = 'content product product-lists-page product-lists-page--wide';
                }
				prdList.forEach(function(el){
					el.className = 'prd-list prd-list--wide';
				})
			}else{
				targetBtn.className = 'js-btn-col'

                if(document.querySelector('.search-product-lists-page')){
                    prdListPage.className = 'content product product-lists-page search-product-lists-page';
                }else{
                    prdListPage.className = 'content product product-lists-page';
                }
				prdList.forEach(function(el){
					el.className = 'prd-list';
				})
			}
		});
    }

    // product - product-view-page
    if(document.querySelector('.product-view-page')){
        let slider = $('.slide-list'),
            prdSlider = $('.prd-silde .prd-list');

        let sliderOptions = {
			lazyLoad: 'ondemand',
            dots:false,
            arrows:false,
            speed:1300,
        };
        let prdSliderOptions = {
			lazyLoad: 'ondemand',
            dots:false,
            arrows:false,
            speed:1300,
            variableWidth: true,
        };

        $(window).on('load resize', function() {
            if($(window).width() < 768) {
                slider.not('.slick-initialized').slick(sliderOptions).on('beforeChange', function(event, slick, currentSlide, nextSlide) {
                    $(".slide-area__control .current").html(nextSlide + 1);
                });
                $(".slide-area__control .total").html($(".slide-list .slide-list__item").length - 2);

                if(prdSlider.hasClass('slick-slider')){
                    prdSlider.slick('unslick');
                }
            }else{
                if(slider.hasClass('slick-slider')){
                    slider.slick('unslick');
                }

                prdSlider.not('.slick-initialized').slick(prdSliderOptions);
            }
        });
    }
});
